/**
 * 图标：lucide-react。日程 / 奖品的图标键（docs/API.md）映射到 lucide 图标，与 iOS KPIcon（SF Symbols）对应。
 * 页面里其它图标直接 import { Xxx } from "lucide-react"。
 */
import {
  Backpack,
  Book,
  BookA,
  Dumbbell,
  Film,
  Gamepad2,
  Gift,
  GraduationCap,
  House,
  Moon,
  Music,
  Palette,
  Pencil,
  Sandwich,
  Star,
  ToyBrick,
  Trees,
  Utensils,
  Waves,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

const MAP: Record<string, LucideIcon> = {
  school: GraduationCap,
  snack: Utensils,
  homework: Pencil,
  music: Music,
  meal: Utensils,
  book: Book,
  moon: Moon,
  swim: Waves,
  art: Palette,
  park: Trees,
  home: House,
  movie: Film,
  bag: Backpack,
  sport: Dumbbell,
  english: BookA,
  game: Gamepad2,
  gift: Gift,
  food: Sandwich,
  toy: ToyBrick,
  star: Star,
};

/** 图标键对应的 lucide 组件，未知的键用星星 */
export function iconFor(key: string | null | undefined): LucideIcon {
  return MAP[key ?? ""] ?? Star;
}

/** 日程 / 奖品图标：<KPIcon name={event.icon} size={20} /> */
export function KPIcon({ name, size = 20, strokeWidth = 2.2, ...rest }: { name: string | null | undefined } & LucideProps) {
  const I = iconFor(name);
  return <I size={size} strokeWidth={strokeWidth} {...rest} />;
}

/** 编辑日程时可选的图标 */
export const EVENT_ICON_KEYS = ["school", "homework", "music", "meal", "snack", "book", "moon", "swim", "art", "park", "home", "movie", "bag", "sport", "english", "star"] as const;
/** 奖品可选的图标 */
export const REWARD_ICON_KEYS = ["park", "game", "gift", "food", "movie", "toy"] as const;
